"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = '4.24.8';
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/version.js
// module id = 1312
// module chunks = 0